/**
 * 枚举信息
 */

import request from '@/utils/request'

/**
 * 根据类型获取数据子典枚举
 * @param type 1：技术领域 2：企业类型 3：员工人数 4：年销售额 5:适应症
 * @param dicStatus  0无效1有效3全部(字符串)默认有效
 */
export function baseEnumsSelectDictionariesType(type,dicStatus) {
  return request({
    url: '/base/enums/select/dictionaries/type',
    method: 'post',
    data: { type: type,dicStatus:dicStatus }
  })

  //   返回值
  //   {
  //     "code": 200,
  //     "data": [
  //         {
  //             "key": "TECHNICAL_AREA_01",
  //             "value": "Synthetic Molecule",
  //             "valueEn": "合成分子"
  //         }
  //     ]
  //   }
}
/**
 * 新增公司时的技术领域
 * 
 */
export function baseEnumsAvaliableTechnicalArea() {
  return request({
    url: '/base/enums/select/avaliable/technicalArea',
    method: 'post',
    data: { }
  })
}
/**
 * 获取地区/国家枚举
 * @param higherNo 获取顶级传 0
 */
export function baseEnumsSelectAreaNo(higherNo) {
  return request({
    url: '/base/enums/select/area/no',
    method: 'post',
    data: { higherNo: higherNo }
  })

  //   返回值
  //   {
  //     "code": 200,
  //     "data": [
  //       {
  //           "areaNo": "001000",
  //           "name": "亚洲",
  //           "nameEn": "Asia"
  //       }
  //     ]
  //   }
}

/**
 * 获取公司枚举
 * @param data 
 */
export function MyCompanyList(data) {
  data = data || {}
  return request({
    url: '/base/enums/select/common',
    method: 'post',
    data
  })
}

/**
 * 获取可用的公司枚举
 * @param data 
 */
export function MyCompanyAvaliableList(data) {
  data = data || {}
  return request({
    url: '/base/enums/select/common/avaliable',
    method: 'post',
    data
  })
}

/**
 * 查询专利的的国家地区
 */
export function baseEnumsSelectAreaPatent() {
  return request({
    url: '/base/enums/select/area/patent',
    method: 'post',
    data: {}
  })
}
